export enum ProgressState {
    NOT_STARTED = "NOT_STARTED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
}

export interface ApiState<T> {
    state: ProgressState;
    data: T | null;
    error?: string;
}

export interface ICity {
    city_id: number;
    city_name: string;
}

export interface ICitiesResponse {
    status_code: number;
    status_message: string;
    data: {
        cities: ICity[];
    };
}

export enum ReferralState {
    PENDING = "PENDING",
    EXPIRED = "EXPIRED",
    EARNED = "EARNED",
    PAYMENT_PENDING = "PAYMENT_PENDING",
}

export interface IReferee {
    city_id: string;
    phone_number: string;
    name: string;
    ozone_id: string;
    image_url?: string;
}

export interface IReferral {
    referee: IReferee;
    referral_time: number;
    referral_id: string;
    referral_state: ReferralState;
    bonus_earned?: string;
    referral_expire_at?: number;
}

export interface IListReferralsResponse {
    status_code: number;
    status_message: string;
    data: {
        referrals: IReferral[];
    };
}

export interface IListReferralsPayload {
    request_id: string;
    client_id: string;
}

export interface IBanner {
    image: string;
    deep_link: string;
}

export interface IHomeBannersResponse {
    status_code: number;
    status_message: string;
    data: {
        banners: IBanner[];
    };
}

export interface IUserDetails {
    name: string;
    city: string;
    pan_number: string;
    bank_name: string;
    account_number: string;
}

export interface IReferralData {
    total_referrred: number;
    total_pending: number;
    total_paid_referrals: number;
    earned_amount: string;
}

export interface IUserData {
    id: string;
    user_details: IUserDetails;
    referral_data: IReferralData;
}

export interface IUserDataResponse {
    status_code: number;
    status_message: string;
    data: IUserData;
}

export interface IHomePageData {
    cities: ApiState<ICity[]>;
    referrals: ApiState<IReferral[]>;
    banners: ApiState<IBanner[]>;
    userData: ApiState<IUserData>;
    initialLoadComplete: boolean;
}

export interface IRefereePayload {
    city_id: string;
    phone_number: string;
    name: string;
}

export interface ICreateReferralPayload {
    request_id: string;
    client_id: string;
    referee: IRefereePayload;
}

export interface ICreateReferralErrorData {
    error_code: string;
    error_message: string;
}

export interface ICreateReferralResponse {
    status_code: number;
    status_message: string;
    data: {
        referral?: IReferral;
        error_code?: string;
        error_message?: string;
    };
}
